import { useState } from 'react';
import { Newspaper, LayoutDashboard, List, Calendar } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import MarketingBlogResumen from './MarketingBlogResumen';
import MarketingBlogInventario from './MarketingBlogInventario';
import MarketingBlogPlanEditorial from './MarketingBlogPlanEditorial';

/**
 * /marketing/blog/ — Hub del canal Blog.
 *
 * Tabs (Fase 1 operativas; el resto son placeholders hasta Fases 2-3):
 *   - Resumen: KPIs + top posts + posts en declive.
 *   - Inventario: tabla de los posts publicados con métricas y flags.
 *   - GEO: visibilidad en IAs (placeholder, Fase 3).
 *   - Plan editorial: cruce con el plan (placeholder, Fase 3).
 */
export default function MarketingBlog() {
  const [tab, setTab] = useState('resumen');

  return (
    <div className="p-6 max-w-[1400px] mx-auto">
      <div className="flex items-center gap-3 mb-2">
        <Newspaper className="w-7 h-7 text-duetto-primary" />
        <h1 className="text-2xl font-bold text-duetto-primary">Blog</h1>
      </div>
      <p className="text-sm text-gray-500 mb-6">
        Rendimiento de los artículos publicados en{' '}
        <span className="font-medium">duettocatering.com/blog</span>.
      </p>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="resumen" className="flex items-center gap-2">
            <LayoutDashboard className="w-4 h-4" />
            Resumen
          </TabsTrigger>
          <TabsTrigger value="inventario" className="flex items-center gap-2">
            <List className="w-4 h-4" />
            Inventario
          </TabsTrigger>
          <TabsTrigger value="plan" className="flex items-center gap-2">
            <Calendar className="w-4 h-4" />
            Plan editorial
          </TabsTrigger>
        </TabsList>

        {/* Carga perezosa: solo renderizamos el contenido del tab activo. */}
        <TabsContent value="resumen">
          {tab === 'resumen' && <MarketingBlogResumen />}
        </TabsContent>
        <TabsContent value="inventario">
          {tab === 'inventario' && <MarketingBlogInventario />}
        </TabsContent>
        <TabsContent value="plan">
          {tab === 'plan' && <MarketingBlogPlanEditorial />}
        </TabsContent>
      </Tabs>
    </div>
  );
}
